import React, { useState } from "react";
import "../../styles/main.css";

import ContainerBase from "../../components/framepart/SubpageLayout/ContainerBase";

import ActivityStructureTab from "../../components/defined/activity_overview/ActivityStructureTab";
import ActivityStructurePanel from "../../components/defined/activity_overview/ActivityStructurePanel";

import ActivityAnalysisView from "../../components/defined/activity_analysis/ActivityAnalysisView";
import ActivityAnalysisPanel from "../../components/defined/activity_analysis/ActivityAnalysisPanel";

import ActivityStructuringBoard from "../../components/defined/activity_structuring/ActivityStructuringBoard";
import ActivityStructuringInsightsPanel from "../../components/defined/activity_structuring/ActivityStructuringInsightsPanel";

import ActivitySequencingBoard from "../../components/defined/activity_sequencing/ActivitySequencingBoard";

import ActivitySequencingPanel from "../../components/defined/activity_sequencing/ActivitySequencingPanel";

import ActivityReviewBoard from "../../components/defined/activity_review/ActivityReviewBoard";

import ActivityReviewPanel from "../../components/defined/activity_review/ActivityReviewPanel";

// import Template_B0 from "../../components/templates/corelia_B0";




import JourneyTabs from "../../components/reusable/Navigation/JourneyTabs";

/* ============================================================
   DONNÉES INITIALES — ANALYSIS
   ----------------------------------------------------------------
   Source unique de vérité pour :
   - matrixData
   - sandboxItems
============================================================ */

const buildInitialMatrixData = () => {
  const raw = {
    eqp: {
      proc: [
        { title: "Pompes", quantity: "12 u", supply: "Import", intensity: "Critique" },
        { title: "Skids process", quantity: "4 u", supply: "Import", intensity: "Lourd" },
      ],
      elec: [
        { title: "Armoires électriques", quantity: "8 u", supply: "Local", intensity: "Standard" },
      ],
    },
    mat: {
      gc: [
        { title: "Béton structurel", quantity: "2 400 m³", supply: "Local", intensity: "Lourd" },
      ],
      net: [
        { title: "Tuyauterie", quantity: "850 ml", supply: "Mixte", intensity: "Lourd" },
        { title: "VRD", quantity: "1 200 m²", supply: "Local", intensity: "Standard" },
      ],
    },
    lab: {
      gc: [
        { title: "Coffrage", quantity: "18 équipes", supply: "Interne", intensity: "Lourd" },
      ],
      net: [
        { title: "Pose réseaux", quantity: "12 équipes", supply: "Sous-traitance", intensity: "Critique" },
      ],
      proc: [
        { title: "Montage équipements", quantity: "6 équipes", supply: "Mixte", intensity: "Critique" },
      ],
      elec: [
        { title: "Câblage", quantity: "4 équipes", supply: "Interne", intensity: "Standard" },
      ],
    },
  };

  const enriched = {};

  Object.keys(raw).forEach((columnKey) => {
    enriched[columnKey] = {};

    Object.keys(raw[columnKey]).forEach((tradeKey) => {
      enriched[columnKey][tradeKey] = raw[columnKey][tradeKey].map((item, index) => ({
        ...item,
        id: `${columnKey}-${tradeKey}-${index + 1}`,
        label: item.title,
        columnKey,
        tradeKey,
        originColumnKey: columnKey,
        originTradeKey: tradeKey,
      }));
    });
  });

  return enriched;
};

/* ============================================================
   STYLES COMMUNS DES CONTAINERS
============================================================ */

const baseLeftZoneStyle = {
  flex: 3,
  minWidth: 700,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  overflowX: "auto",
  overflowY: "auto",
  flexShrink: 0,
};

const baseRightZoneStyle = {
  flex: 1,
  minWidth: 350,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  overflowX: "auto",
  overflowY: "auto",
  boxSizing: "border-box",
  flexShrink: 0,
};



/* ============================================================
   PAGE
============================================================ */

const Subpage_110 = () => {
  const [activeTab, setActiveTab] = useState(0);

  /* ------------------------------------------------------------
     SOURCE UNIQUE DE VÉRITÉ — ANALYSIS
  ------------------------------------------------------------ */
  const [matrixData, setMatrixData] = useState(buildInitialMatrixData);
  const [sandboxItems, setSandboxItems] = useState([]);
  const [selectedSequencingPackage, setSelectedSequencingPackage] = useState(null);

  /* ============================================================
     ZONE A — FLOW
  ============================================================ */

  const zoneA1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: <ActivityStructureTab />,
      },
    ],
  };

  const zoneA2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: <ActivityStructurePanel />,
      },
    ],
  };

  /* ============================================================
     ZONE B — ANALYSIS
  ============================================================ */

  const zoneB1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: (
          <ActivityAnalysisView
            matrixData={matrixData}
            setMatrixData={setMatrixData}
            sandboxItems={sandboxItems}
            setSandboxItems={setSandboxItems}
          />
        ),
      },
    ],
  };

  const zoneB2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "",
        title: "",
        content: (
          <ActivityAnalysisPanel
            sandboxItems={sandboxItems}
            setSandboxItems={setSandboxItems}
            setMatrixData={setMatrixData}
          />
        ),
      },
    ],
  };

  /* ============================================================
     ZONE C — STRUCTURING
  ============================================================ */

  const zoneC1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: <ActivityStructuringBoard />,
      },
    ],
  };

  const zoneC2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        icon: "",
        title: "",
        content: <ActivityStructuringInsightsPanel />,
      },
    ],
  };

  /* ============================================================
     ZONE D — SEQUENCING
  ============================================================ */

  const zoneD1 = {
  style: baseLeftZoneStyle,
  gap: 16,
  sectionGap: 6,
  sections: [
    {
      title: "",
      content: (
        <ActivitySequencingBoard
          onSelectPackage={setSelectedSequencingPackage}
        />
      ),
    },
  ],
};

  const zoneD2 = {
  style: baseRightZoneStyle,
  gap: 12,
  sectionGap: 6,
  sections: [
    {
      icon: "",
      title: "",
      content: (
        <ActivitySequencingPanel
          selectedPackage={selectedSequencingPackage}
          useMock={!selectedSequencingPackage}
        />
      ),
    },
  ],
};

  /* ============================================================
     ZONE E — PLANNING
  ============================================================ */

 
  const zoneE1 = {
  style: baseLeftZoneStyle,
  gap: 16,
  sectionGap: 6,
  sections: [
    {
      title: "",
      content: (
        <ActivityReviewBoard
          onSelectPackage={setSelectedSequencingPackage}
        />
      ),
    },
  ],
};

  const zoneE2 = {
  style: baseRightZoneStyle,
  gap: 12,
  sectionGap: 6,
  sections: [
    {
      icon: "",
      title: "",
      // content: (
      //   <Template_B0
      //     selectedPackage={selectedSequencingPackage}
      //     useMock={!selectedSequencingPackage}
      //   />
      // ),
    },
  ],
};

  /* ============================================================
     TABS
  ============================================================ */

  const tabStyle = {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    padding: 10,
    overflowY: "clip",
    overflowX: "hidden",
    minWidth: "fit-content",
    boxSizing: "border-box",
  };

  const tabs = [
    {
      label: "Phasing",
      content: (
        <div style={tabStyle}>
          <ContainerBase {...zoneA1} />
          <ContainerBase {...zoneA2} />
        </div>
      ),
    },
    {
      label: "Workload",
      content: (
        <div style={tabStyle}>
          <ContainerBase {...zoneB1} />
          <ContainerBase {...zoneB2} />
        </div>
      ),
    },
    {
      label: "Packages",
      content: (
        <div style={tabStyle}>
          <ContainerBase {...zoneC1} />
          <ContainerBase {...zoneC2} />
        </div>
      ),
    },
    {
      label: "Sequencing",
      content: (
        <div style={tabStyle}>
          <ContainerBase {...zoneD1} />
          <ContainerBase {...zoneD2} />
        </div>
      ),
    },
    {
      label: "Report",
      content: (
        <div style={tabStyle}>
          <ContainerBase {...zoneE1} />
          <ContainerBase {...zoneE2} />
        </div>
      ),
    },
  ];

  /* ============================================================
     RENDER
  ============================================================ */

  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        width: "100%",
        height: "100%",
        overflowX: "hidden",
        overflowY: "visible",
      }}
    >
      <JourneyTabs
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      componentWidth="50%"
      stepsWidth="100%"
      componentOffsetLeft={0}
      headerPaddingLeft={24}
      tabsDisabled={false}
      containerStyle={{
        height: "calc(100vh - 160px)",
        minHeight: "calc(100vh - 160px)",
        overflow: "hidden",
      }}
    />
    </div>
  );
};

export default Subpage_110;